module.exports = __webpack_public_path__ + "img/metro_post.b8573f50.jpg";